import { isValid, parseISO, format } from 'date-fns';
/**
 * Generates a tooltip string for earnings data.
 *
 * @param {any | null} data - The earnings data object containing a date property 'd'.
 * @param {number | null} days - The number of days until or since the earnings date.
 * @returns {string} - A formatted string indicating the earnings date and relative time.
 */

export const getEarningsTooltip = (data: any | null, days: number | null): string => {
  if (!data?.d) return 'No earnings data';

  try {
    const earningsDate = parseISO(data.d);
    if (!isValid(earningsDate)) return 'Invalid earnings date';

    const formattedDate = format(earningsDate, 'M/d');

    if (days === null) return `Earnings on ${formattedDate}`;

    if (days === 0) return `Earnings on ${formattedDate} (Today)`;
    if (days === 1) return `Earnings on ${formattedDate} in 1 day`;
    if (days > 0) return `Earnings on ${formattedDate} in ${days} days`;
    if (days === -1) return `Earnings on ${formattedDate} (1 day ago)`;
    return `Earnings on ${formattedDate} (${Math.abs(days)} days ago)`;
  } catch (error) {
    return 'Invalid earnings date';
  }
};
